export const TABLE_VIEW_TYPE = {
    // 桌台列表
    INDEX: 'index',
    // 桌台详情
    DETAIL: 'detail',
    // 会员详情
    LOOK_USER_INFO: 'lookUserInfo',
    // 挂单列表
    PENDING_ORDER: 'pendingOrder',
    // 结账
    CHECK_BILL: 'checkBill',
    // 结账挂单结账
    CHECK_PENDING_BILL: 'checkPendingBill',
    // 结账现金支付
    PAY: 'pay',
    // 充值弹窗
    PAY_CHECK_BILL: 'payCheckBill'
};
export const PAY_TYPE = {
    // 现金支付
    CASH: 'cash',
    // 聚合支付
    AGGREGATE: 'aggregate',
    //扫码支付
    SCAN: 'scan',
    // 会员余额
    BALANCE: 'balance',
    // 团购支付
    GROUP_BUY: 'group_buy'
};
//消费结账
export const CONSUMPTION_VIEW_TYPE = {
    CHECK_BILL: 'checkBill',
    INDEX: 'index'
};
// 顶部选项卡
export const TOP_TABS = [
    {
        name: '桌台列表',
        index: 0
    },
    {
        name: '教练状态',
        index: 1
    }
];
// 账单顶部选项卡
export const BILL_TOP_TABS = [
    {
        name: '业务账单',
        index: 0
    },
    {
        name: '退款账单',
        index: 1
    }
];
// 账单顶部选项卡
export const BILL_TOP_SHIFT = [
    {
        name: '交接班记录',
        index: 0
    }
    // {
    //     name: '日切记录',
    //     index: 1
    // }
];
export const BILL_PAGE_TAB = {
    // 消费账单
    TABLE: 0,
    // 退款账单
    REFUND_TABLE: 1
};
// 会员顶部选项卡
export const MEMBER_TOP_TABS = [
    {
        name: '本金余额变动',
        index: 0
    },
    {
        name: '赠金余额变动',
        index: 1
    },
    {
        name: '积分变动',
        index: 2
    }
];
// 顶部 tabs切换 tabActive 的值
export const PAGE_TAB = {
    // 桌台列表
    TABLE: 0,
    // 教练状态
    COACH: 1
};
// 桌台接口参数：getRoomList({ type })
// 0=全部 1=散桌 2=包间
export const ROOM_TYPE = {
    // 全部
    ALL: 0,
    // 散桌
    SANDESK: 1,
    // 包间
    PRIVATE: 2
};
// 教练接口参数：getCoachList({ all })
// 1=全部 0=休息中 3=空闲中 2=工作中
export const COACH_FILTER = {
    // 全部类型
    ALL: 1,
    // 休息中
    REST: 0,
    // 空闲中
    FREE: 3,
    // 工作中
    WORK: 2
};
// 顶部布局方式
export const LAYOUT_SIZE_OPTIONS = [
    {
        name: '小号',
        icon: 'iconfont icon-xiaohao',
        keys: 'small'
    },
    {
        name: '中号',
        icon: 'iconfont icon-zhonghao',
        keys: 'medium'
    },
    {
        name: '大号',
        icon: 'iconfont icon-dahao',
        keys: 'large'
    }
    // {
    // 	name: '平铺',
    // 	icon: 'iconfont icon-xiaohao',
    // 	keys: 'flat'
    // }
];
// 顶部操作
export const HEADER_ACTIONS = [
    // {
    // 	name: '消息',
    // 	icon: 'iconfont icon-xiaoxi',
    // 	keys: 'message'
    // },
    {
        name: '挂单',
        icon: 'iconfont icon-guadan2',
        keys: 'order'
    },
    {
        name: '刷新',
        icon: 'iconfont icon-shuaxin',
        keys: 'refresh'
    }
];
export const HEADER_ACTIONS_REFRESH = [
    {
        name: '刷新',
        icon: 'iconfont icon-shuaxin',
        keys: 'refresh'
    }
    // {
    // 	name: '消息',
    // 	icon: 'iconfont icon-xiaoxi',
    // 	keys: 'message'
    // },
    // {
    // 	name: '挂单',
    // 	icon: 'iconfont icon-guadan',
    // 	keys: 'order'
    // }
];
// 顶部返回右边的操作按钮
export const TOP_ACTIONS = [
    {
        icon: 'iconfont icon-guandeng',
        key: 'offLight'
    },
    {
        icon: 'iconfont icon-kaideng',
        key: 'onLight'
    },
    {
        icon: 'iconfont icon-dayin',
        key: 'print'
    },
    {
        icon: 'iconfont icon-shuaxin',
        key: 'refresh'
    }
];

// 商品餐食教练礼物
export const TOP_CARD_TYPES = [
    {
        name: '商品',
        key: 'shop'
    },
    {
        name: '餐食',
        key: 'food'
    },
    {
        name: '教练',
        key: 'coach'
    },
    {
        name: '礼物',
        key: 'gift'
    }
];
// 商品餐食教练
export const TOP_CON_TYPES = [
    {
        name: '商品',
        key: 'shop'
    },
    {
        name: '餐食',
        key: 'food'
    },
    {
        name: '教练',
        key: 'coach'
    }
];
// 顶部操作菜单
export const TOP_MENU_ACTIONS = [
    // {
    // 	name: '清台',
    // 	icon: 'iconfont icon-qingtai',
    // 	keys: 'clear'
    // },
    {
        name: '取消',
        icon: 'iconfont icon-quxiao',
        keys: 'cancel'
    },
    {
        name: '挂单',
        icon: 'iconfont icon-guadan2',
        keys: 'order'
    },
    // {
    //     name: '拆单',
    //     icon: 'iconfont icon-chaitai',
    //     keys: 'split'
    // },
    // {
    // 	name: '联台',
    // 	icon: 'iconfont icon-liantai',
    // 	keys: 'join'
    // },
    {
        name: '截开',
        icon: 'iconfont icon-caozuo',
        keys: 'cut'
    },
    // {
    // 	name: '绩效',
    // 	icon: 'iconfont icon-jiekai',
    // 	keys: 'performance'
    // },
    {
        name: '大屏操作',
        icon: 'iconfont icon-shebeixinxi',
        keys: 'hardware'
    },
    {
        name: '操作日志',
        icon: 'iconfont icon-caozuorizhi',
        keys: 'log'
    },
    // {
    //     name: '恢复计费',
    //     icon: 'iconfont icon-shijian',
    //     keys: 'recharge'
    // },
    {
        name: '选择套餐',
        icon: 'iconfont icon-jixiao',
        keys: 'activity'
    },
    {
        name: '开灯',
        icon: 'iconfont icon-kaideng',
        keys: 'light'
    }
];
